import script from "./ArticlesBlockSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticlesBlockSkeleton.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__